import React from "react";
import { Tabs, TabsProps } from "antd";
import WidgetDrawer from "./WidgetDrawer";
import {
    TrendsComparisionWidget,
    ReviewsAndVerbatimTableWidget,
} from "@components/widgets";
import { IAllReviewsWidget } from "@ts/common-types";

const items: TabsProps["items"] = [
    { label: "All", key: "all" },
    { label: "Positive", key: "positive" },
    { label: "Negative", key: "negative" },
];

const AllReviewsWidget: React.FC<IAllReviewsWidget> = ({
    title,
    show,
    setShow,
    widgetData,
    activeReviewTab,
    setActiveReviewTab,
}) => {
    const onClose = () => {
        setShow(false);
        setActiveReviewTab("all");
    };

    return (
        <WidgetDrawer
            title={title}
            width="85vw"
            show={show}
            onClose={onClose}
            bodyStyle={{ backgroundColor: "#FFFFFF" }}
        >
            <TrendsComparisionWidget
                title="All Reviews"
                isTitleRequired={false}
                isCardRequired={false}
                widgetData={widgetData.chart}
            />
            <Tabs
                className="pa-custom-tabs w-100 mb-2"
                activeKey={activeReviewTab || "all"}
                items={items}
                onChange={(key) => setActiveReviewTab(key)}
            />
            <ReviewsAndVerbatimTableWidget widgetData={widgetData.table} />
        </WidgetDrawer>
    );
};

export default AllReviewsWidget;
